import styled from 'styled-components'

export const Container = styled.div`
    position: sticky;
    height: ${(props) => {return props.theme.headerHeight}}px;
    top: 0;
    z-index: 1000;
    font-size: 1.3rem;
    font-weight: 700;
    background: ${(props) => {return props.theme.colorSecoundary}};
    box-shadow: ${(props) => {return props.theme.shadow}};

    @media screen and (max-width: 992px) {
        #idContainer {
            position: fixed;
            top: 25px;
        }

        .navbar-collapse {
            background: #f8f9fa;
            border-top: 0px solid white;
            box-shadow: rgb(0 0 0 / 10%) 0px 4px 6px -1px;
        }

        ul {
            padding-bottom: 10px;
        }
    }

    @media screen and (max-width: 580px) {
        #idContainer {
            top: 25px;
            position: fixed;
            padding-right: 30px;
        }

        button {
            margin-right: 50px;
        }
    }

    .navbar {
        position: absolute;
        top: 0;
        height: 100%;
    }

    a {
        color: ${(props) => {return props.theme.colorPrimary}} !important;
        line-height: 29.05px;
        transition: 0.3s ease-in-out;

        :hover {
            transform: scale(1.04);
        }
    }

    button {
        background: ${(props) => {return props.theme.colorPrimary}};
        color: ${(props) => {return props.theme.colorSecoundary}};
        border-radius: 5px;
    }

`
